import { render, staticRenderFns } from "./LastEdits.vue?vue&type=template&id=59050ea2&scoped=true&"
import script from "./LastEdits.vue?vue&type=script&lang=js&"
export * from "./LastEdits.vue?vue&type=script&lang=js&"
import style0 from "./LastEdits.vue?vue&type=style&index=0&id=59050ea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59050ea2",
  null
  
)

export default component.exports